import React from 'react';
import { Col } from 'antd';

interface ImportSummaryProps {
  ingressType?: string;
  headerMappingsLength: number;
  allMappedSchoolsLength: number;
  roleMappingsLength: number;
  schoolsLength?: number;
}

const ImportSummary: React.FC<ImportSummaryProps> = ({
  ingressType = 'staff-records',
  headerMappingsLength,
  allMappedSchoolsLength,
  roleMappingsLength,
  schoolsLength,
}) => {
  return (
    <>
      <Col span="24" className="import-summary-container">
        <span className="import-summary-title" data-test-id="import-summary-title-txt">
          Import Summary
        </span>
        <div className="import-summary-content">
          <div className="import-summary-headers">
            <span className="import-summary-header">Headers</span>
            <span className="import-summary-header">Schools</span>
            {ingressType === 'staff-records' && <span className="import-summary-header">Roles</span>}
          </div>
          <div className="import-summary-values">
            <span className="import-summary-value">{`${headerMappingsLength} headers mapped`}</span>
            <span className="import-summary-value">
              {schoolsLength
                ? `${schoolsLength} Selected schools`
                : `${allMappedSchoolsLength} Selected schools`}
            </span>
            {ingressType === 'staff-records' && <span className="import-summary-value">{`${roleMappingsLength} roles mapped`}</span>}
          </div>
        </div>
      </Col>
      <br />
      <Col span="16" data-test-id="import-info-txt">
        <span className="pagepara">
          This import has not been started yet. If you have completed the previous steps, you can run a test import or
          start an import now. The import may take a few minutes to complete. To keep the import in sync, send the same
          file to your SFTP portal outside of Naviance. Naviance will monitor the SFTP URL for new files.
        </span>
      </Col>
    </>
  );
};

export default ImportSummary;